<template>

  <div class="auth-panel">

    <div v-if="user" class="auth-user">

      <span>{{ user.email }}</span>

      <el-tag v-if="!user.emailVerified" type="warning" size="mini">未验证</el-tag>

      <el-tag v-else type="success" size="mini">{{ planLabel(user.plan) }}</el-tag>

      <el-button v-if="!user.emailVerified" size="mini" @click="showVerify = true">验证邮箱</el-button>

      <el-button size="mini" @click="$emit('logout')">退出</el-button>

    </div>

    <div v-else class="auth-guest">

      <el-button type="primary" size="small" @click="openDialog('login')">登录</el-button>

      <el-button size="small" @click="openDialog('register')">注册</el-button>

    </div>



    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="440px" @close="resetForm">

      <el-form v-if="mode === 'login'" label-width="80px">

        <el-form-item label="邮箱"><el-input v-model="form.email" /></el-form-item>

        <el-form-item label="密码"><el-input v-model="form.password" type="password" show-password /></el-form-item>

        <el-button type="text" @click="mode = 'forgot'">忘记密码？</el-button>

      </el-form>

      <el-form v-else-if="mode === 'register'" label-width="80px">

        <el-form-item label="邮箱"><el-input v-model="form.email" /></el-form-item>

        <el-form-item label="密码"><el-input v-model="form.password" type="password" show-password /></el-form-item>

        <el-form-item label="邀请码"><el-input v-model="form.inviteCode" placeholder="可选" /></el-form-item>

        <el-form-item label-width="0">

          <el-checkbox v-model="form.agreedToTerms">

            我已阅读并同意

            <el-button type="text" @click="openTerms">用户协议与隐私说明</el-button>

          </el-checkbox>

        </el-form-item>

        <p class="hint-mail">{{ verificationHint }}</p>

      </el-form>

      <el-form v-else-if="mode === 'forgot'" label-width="80px">

        <el-form-item label="邮箱"><el-input v-model="form.email" /></el-form-item>

        <p class="hint-mail">{{ passwordResetHint }}</p>

      </el-form>

      <el-form v-else-if="mode === 'reset'" label-width="90px">

        <el-form-item label="邮箱"><el-input v-model="form.email" /></el-form-item>

        <el-form-item label="重置码"><el-input v-model="form.code" maxlength="6" /></el-form-item>

        <el-form-item label="新密码"><el-input v-model="form.newPassword" type="password" show-password /></el-form-item>

      </el-form>

      <el-form v-else label-width="80px">

        <el-form-item label="邮箱"><el-input v-model="form.email" :disabled="!!user" /></el-form-item>

        <el-form-item label="验证码"><el-input v-model="form.code" maxlength="6" /></el-form-item>

        <el-button type="text" class="resend-btn" :disabled="resendCooldownSec > 0 || resendLoading" @click="onResend">{{ resendButtonLabel }}</el-button>

      </el-form>

      <span slot="footer">

        <el-button @click="dialogVisible = false">取消</el-button>

        <el-button type="primary" :loading="loading" @click="onSubmit">确定</el-button>

      </span>

    </el-dialog>



    <el-dialog title="验证邮箱" :visible.sync="showVerify" width="420px">

      <el-form label-width="80px">

        <el-form-item label="邮箱"><el-input :value="user && user.email" disabled /></el-form-item>

        <el-form-item label="验证码"><el-input v-model="form.code" maxlength="6" /></el-form-item>

      </el-form>

      <span slot="footer">

        <el-button type="text" class="resend-btn" :disabled="resendCooldownSec > 0 || resendLoading" @click="onResend">{{ resendButtonShortLabel }}</el-button>

        <el-button type="primary" :loading="loading" @click="onVerify">验证</el-button>

      </span>

    </el-dialog>

  </div>

</template>



<script>

import {

  login,

  register,

  verifyEmail,

  resendVerification,

  forgotPassword,

  resetPassword,

} from '../api/auth';

import { APP_ENV } from '../config';

import {
  getResendCooldownRemainingSec,
  markResendSent,
} from '../constants/authMailLimits';

import { setAuthSession } from '../utils/authStorage';

import { planLabel } from '../constants/planLabels';



export default {

  name: 'AuthPanel',

  props: {

    user: { type: Object, default: null },

  },

  data() {

    return {

      dialogVisible: false,

      showVerify: false,

      mode: 'login',

      loading: false,

      resendLoading: false,

      resendCooldownSec: 0,

      resendTimer: null,

      form: {

        email: '',

        password: '',

        newPassword: '',

        inviteCode: '',

        code: '',

        agreedToTerms: false,

      },

    };

  },

  computed: {

    dialogTitle() {

      if (this.mode === 'register') return '注册内测账号';

      if (this.mode === 'verify') return '验证邮箱';

      if (this.mode === 'forgot') return '找回密码';

      if (this.mode === 'reset') return '重置密码';

      return '登录';

    },

    verificationHint() {

      return APP_ENV === 'local'

        ? '本地开发：验证码见 Java 控制台日志'

        : '注册后将向邮箱发送 6 位验证码，请查收（含垃圾箱）';

    },

    passwordResetHint() {

      return APP_ENV === 'local'

        ? '本地开发：重置码见 Java 控制台日志'

        : '若邮箱已注册，将向邮箱发送重置验证码';

    },

    resendEmail() {

      return this.form.email || (this.user && this.user.email) || '';

    },

    resendButtonLabel() {

      if (this.resendLoading) return '发送中…';

      if (this.resendCooldownSec > 0) return `${this.resendCooldownSec}s 后可重发`;

      return '重新发送验证码';

    },

    resendButtonShortLabel() {

      if (this.resendLoading) return '发送中…';

      if (this.resendCooldownSec > 0) return `${this.resendCooldownSec}s 后可重发`;

      return '重新发送';

    },

  },

  watch: {

    showVerify(val) {

      if (val) this.syncResendCooldown();

    },

  },

  mounted() {

    this.syncResendCooldown();

  },

  beforeDestroy() {

    this.clearResendTimer();

  },

  methods: {

    planLabel,

    clearResendTimer() {

      if (this.resendTimer) {

        clearInterval(this.resendTimer);

        this.resendTimer = null;

      }

    },

    syncResendCooldown() {

      this.clearResendTimer();

      const tick = () => {

        this.resendCooldownSec = getResendCooldownRemainingSec(this.resendEmail);

        if (this.resendCooldownSec <= 0) this.clearResendTimer();

      };

      tick();

      if (this.resendCooldownSec > 0) {

        this.resendTimer = setInterval(tick, 1000);

      }

    },

    showMailSentMessage(msg, fallback) {

      const text = msg || fallback;

      if (APP_ENV === 'local') {

        this.$message.warning(text);

      } else {

        this.$message.success(text);

      }

    },

    openDialog(mode) {

      this.mode = mode;

      this.dialogVisible = true;

    },

    openTerms() {
      this.dialogVisible = false;
      this.$emit('open-page', 'beta');
    },

    resetForm() {

      this.form.code = '';

    },

    saveSession(data) {

      setAuthSession(data.accessToken, data.user, data.refreshToken);

    },

    async onSubmit() {

      this.loading = true;

      try {

        if (this.mode === 'login') {

          const data = await login({ email: this.form.email, password: this.form.password });

          this.saveSession(data);

          this.$emit('auth-change', data.user);

          this.dialogVisible = false;

          this.$message.success('登录成功');

        } else if (this.mode === 'register') {

          if (!this.form.agreedToTerms) {

            this.$message.warning('请先勾选用户协议与隐私说明');

            return;

          }

          const data = await register({

            email: this.form.email,

            password: this.form.password,

            inviteCode: this.form.inviteCode || undefined,

            agreedToTerms: true,

          });

          const { _message, ...session } = data;

          this.saveSession(session);

          this.$emit('auth-change', session.user);

          this.dialogVisible = false;

          this.showVerify = true;

          this.form.email = session.user.email;

          this.showMailSentMessage(_message, this.verificationHint);

          markResendSent(session.user.email);

          this.syncResendCooldown();

        } else if (this.mode === 'forgot') {

          const msg = await forgotPassword(this.form.email);

          this.showMailSentMessage(msg, this.passwordResetHint);

          this.mode = 'reset';

        } else if (this.mode === 'reset') {

          await resetPassword({

            email: this.form.email,

            code: this.form.code,

            newPassword: this.form.newPassword,

          });

          this.$message.success('密码已重置，请登录');

          this.mode = 'login';

        }

      } catch (e) {

        this.$message.error(e.message || '操作失败');

      } finally {

        this.loading = false;

      }

    },

    async onVerify() {

      this.loading = true;

      try {

        const data = await verifyEmail({ email: this.form.email || this.user.email, code: this.form.code });

        this.saveSession(data);

        this.$emit('auth-change', data.user);

        this.showVerify = false;

        this.$message.success('邮箱已验证');

      } catch (e) {

        this.$message.error(e.message || '验证失败');

      } finally {

        this.loading = false;

      }

    },

    async onResend() {

      const email = this.resendEmail;

      if (!email) {

        this.$message.warning('请先填写邮箱');

        return;

      }

      if (this.resendCooldownSec > 0) {

        this.$message.warning(`请 ${this.resendCooldownSec} 秒后再试`);

        return;

      }

      this.resendLoading = true;

      try {

        const msg = await resendVerification(email);

        markResendSent(email);

        this.syncResendCooldown();

        this.showMailSentMessage(msg, this.verificationHint);

      } catch (e) {

        this.$message.error(e.message || '发送失败');

      } finally {

        this.resendLoading = false;

      }

    },

  },

};

</script>



<style scoped>

.auth-panel { display: flex; justify-content: flex-end; margin-bottom: 12px; }

.auth-user { display: flex; align-items: center; gap: 8px; font-size: 14px; }

.hint-mail { font-size: 13px; color: #1677ff; line-height: 1.6; margin: 0; }

.resend-btn:not(:disabled) { color: #1677ff; font-weight: 500; }

</style>

